<div sm-restrict-width sm-center [hidden]="isLoading">
  <br />
  <mat-card *ngIf="resetSent">
    <mat-card-title sm-center>
      <mat-icon class="smc-icon-large">email</mat-icon>
      <h4>{{ 'PASSWORD_RESET.CHECK_EMAIL' | translate }}</h4>
    </mat-card-title>

    <mat-card-content sm-center>
      <p>
        {{ 'PASSWORD_RESET.EMAIL_SENT' | translate:{ email: email.value } }}
      </p>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!resetSent">

    <mat-card-title>
      {{ 'PASSWORD_RESET.RESET_YOUR_PASSWORD' | translate }}
    </mat-card-title>
    {{ 'PASSWORD_RESET.FORGOT_INSTRUCTIONS' | translate }}
    <form [formGroup]="passwordResetForm">
      <br />
      <mat-form-field appearance="outline">
        <mat-label>{{ 'PASSWORD_RESET.ENTER_EMAIL' | translate }}</mat-label>
        <input matInput type='text' formControlName="email" />
      </mat-form-field>

      <div *ngIf="!email.valid && submitAttempt">
        <p *ngIf="email.hasError('required')" class='smr-error'>
          {{ 'PASSWORD_RESET.EMAIL_REQUIRED' | translate }}
        </p>
        <p *ngIf="!email.hasError('required') && email.hasError('email')" class='smr-error'>
          {{ 'PASSWORD_RESET.EMAIL_INVALID' | translate }}
        </p>
      </div>
    </form>

  <div sm-center *ngIf="!resetSent">
    <button
      mat-raised-button
      class="smc-button-large smc-button-primary"
      (click)="onSave()"
      >
      {{ 'PASSWORD_RESET.SEND_RESET_EMAIL' | translate }}
    </button>
  </div>
</mat-card>
<br />
</div>

<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
